import { createFileRoute } from '@tanstack/react-router';
import { SettingsLayout } from '@/features/projects/settings/settings-layout';

export const Route = createFileRoute('/_app/p/$projectKey/settings')({
  component: RouteComponent,
});

function RouteComponent() {
  const { projectKey } = Route.useParams();
  return <SettingsLayout projectKey={projectKey} />;
}
